import React from 'react'
import SbEditable from 'storyblok-react'
import Richtext from '../atoms/Richtext'

const IntroBoxBlock = ({ block }) => {
  return (
    <SbEditable content={block}>
      <section
        className={`intro-box-block ${
          block.bg_dark ? 'intro-box-block-dark' : ''
        } ${block.wide ? 'intro-box-block-wide' : ''}`}
      >
        <div className="intro-box-block-wrapper">
          <div className="intro-box-block-container">
            <div className="intro-box-block-text">
              <Richtext text={block.text} />
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default IntroBoxBlock
